// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2YStF","label":"Labeled_label__2CMjo","divider":"Labeled_divider__2yTom"};